import { groupBy } from 'lodash-es';

type ValidGroupTypes = number | string | boolean;
type PickValidGroupKeys<T extends Record<string, any>> = keyof {
  [K in keyof T]: T[K] extends ValidGroupTypes ? T[K] : never;
};

/**
 * @description 基于lodash groupby
 * @description 加强groupby后相关的key类型的推导
 * @description 限制使用定义中值有非基础类型值的K值作为索引
 */
const groupByTs = <T extends Record<string, any>, K extends PickValidGroupKeys<T>>(
  arr: T[],
  k: K,
): Record<T[K], T[] | undefined> => {
  return groupBy(arr, k) as unknown as any;
};

export default groupByTs;
